'use client';

import type { SectionType } from './types';

interface SectionSkeletonProps {
  type: SectionType;
}

export function SectionSkeleton({ type }: SectionSkeletonProps) {
  switch (type) {
    case 'image':
      return <div className="aspect-square bg-muted animate-pulse rounded" />;
    case 'status':
      return <div className="h-6 w-16 bg-muted animate-pulse rounded" />;
    case 'dates':
      return <div className="h-12 bg-muted animate-pulse rounded" />;
    case 'amount':
      return <div className="h-16 bg-muted animate-pulse rounded" />;
    case 'party':
      return <div className="h-14 bg-muted animate-pulse rounded" />;
    case 'items':
      return (
        <div className="space-y-2">
          <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          <div className="h-8 bg-muted animate-pulse rounded" />
          <div className="h-8 bg-muted animate-pulse rounded" />
        </div>
      );
    case 'responses':
      return (
        <div className="space-y-2">
          <div className="h-4 w-32 bg-muted animate-pulse rounded" />
          <div className="h-12 bg-muted animate-pulse rounded" />
          <div className="h-12 bg-muted animate-pulse rounded" />
        </div>
      );
    case 'stats':
      return (
        <div className="grid grid-cols-2 gap-2">
          <div className="h-16 bg-muted animate-pulse rounded" />
          <div className="h-16 bg-muted animate-pulse rounded" />
        </div>
      );
    case 'list':
      return (
        <div className="space-y-2">
          <div className="h-4 w-20 bg-muted animate-pulse rounded" />
          <div className="h-10 bg-muted animate-pulse rounded" />
          <div className="h-10 bg-muted animate-pulse rounded" />
        </div>
      );
    case 'contact':
      return (
        <div className="space-y-2">
          <div className="h-4 w-20 bg-muted animate-pulse rounded" />
          <div className="h-5 bg-muted animate-pulse rounded" />
          <div className="h-5 bg-muted animate-pulse rounded" />
        </div>
      );
    case 'products':
      return (
        <div className="space-y-2">
          <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          <div className="grid grid-cols-2 gap-2">
            <div className="aspect-square bg-muted animate-pulse rounded" />
            <div className="aspect-square bg-muted animate-pulse rounded" />
          </div>
        </div>
      );
    case 'collections':
      return (
        <div className="space-y-2">
          <div className="h-4 w-28 bg-muted animate-pulse rounded" />
          <div className="h-10 bg-muted animate-pulse rounded" />
          <div className="h-10 bg-muted animate-pulse rounded" />
        </div>
      );
    case 'metadata':
      return (
        <div className="space-y-1">
          <div className="h-4 w-8 bg-muted animate-pulse rounded" />
          <div className="h-8 bg-muted animate-pulse rounded" />
        </div>
      );
    case 'odoo_link':
      return (
        <div className="space-y-1">
          <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          <div className="h-10 bg-muted animate-pulse rounded" />
        </div>
      );
    default:
      return <div className="h-8 bg-muted animate-pulse rounded" />;
  }
}
